import type { TourSpec } from "./types";

export const settingsRealmTour: TourSpec = {
  id: "settings-realm",
  version: 1,
  buildSteps: (t) => [
    {
      target: '[data-tour="realm-region-selector"]',
      title: t("settingsRealm.region.title"),
      content: t("settingsRealm.region.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="realm-buying-selector"]',
      title: t("settingsRealm.buying.title"),
      content: t("settingsRealm.buying.body"),
      placement: "bottom",
    },
    {
      target: '[data-tour="realm-selling-selector"]',
      title: t("settingsRealm.selling.title"),
      content: t("settingsRealm.selling.body"),
      placement: "bottom",
    },
    {
      target: '[data-tour="realm-wow-accounts"]',
      title: t("settingsRealm.accounts.title"),
      content: t("settingsRealm.accounts.body"),
      placement: "top",
    },
    {
      target: '[data-tour="realm-save-button"]',
      title: t("settingsRealm.save.title"),
      content: t("settingsRealm.save.body"),
      placement: "top",
    },
  ],
};
